/* **************************************
** MSR Webshop Module (Javascript price list)
** by MSR Electronics GmbH, www.msr.ch
** Pricing valid from 2024-01-15
** Version: 2024-03-22
*************************************** */
var priceList = {
"Hou_145B15Price": 186.00,
"Hou_145B7Price": 324.00,
"Hou_145B4Price": 248.00,
"Hou_145B16Price": 310.00,
"Hou_145B8Price": 448.00,
"Hou_145WDB25Price": 245.00,
"Hou_145WDB23Price": 272.00,
"Hou_145WDB26Price": 373.00,
"Hou_145WDB22Price": 398.00,
"Hou_145W2DB25Price": 245.00,
"Hou_145W2DB23Price": 272.00,
"Hou_145W2DB26Price": 373.00,
"Hou_145W2DB22Price": 398.00,
"Hou_147WDB25Price": 623.00,
"Hou_147WDB26Price": 810.00,
"Hou_147W2DB25Price": 623.00,
"Hou_147W2DB26Price": 810.00,
"Hou_160B7Price": 997.00,
"Hou_160B8Price": 1121.00,
"Hou_165B8Price": 1242.00,
"Hou_165B52Price": 1591.00,
"MSR175B16T2AA5Price": 435.00,
"MSR175B16T6H3P5AA5L2Price": 598.00,
"Hou_175B16T2AA5Price": 435.00,
"Hou_175B16T6H3P5AA5L2Price": 598.00,
"Hou_175B54T2AA5Price": 785.00,
"Hou_175B54T6H3P5AA5L2Price": 948.00,
"Hou_175B56T6H3P5AA5L2GPrice": 1072.00,
"Hou_255B10Price": 411.00,
"Hou_255B11Price": 660.00,
"Hou_385SMB63Price": 324.00,
"Hou_385SMB64Price": 411.00,
"Hou_385SMB65Price": 199.00,
"Hou_385SMB66Price": 287.00,
"Rec_385WDB61Price": 586.00,
"Int_T2Price": 86.00,
"Int_T5Price": 86.00,
"Int_T9Price": 86.00,
"Int_HPrice": 86.00,
"Int_H2Price": 86.00,
"Int_H3Price": 86.00,
"Int_PPrice": 86.00,
"Int_P2Price": 86.00,
"Int_P5Price": 86.00,
"Int_P6Price": 86.00,
"Int_P7Price": 86.00,
"Int_APrice": 86.00,
"Int_A3Price": 203.00,
"Int_A4Price": 186.00,
"Int_LPrice": 86.00,
"Int_L2Price": 86.00,
"Int_L3Price": 86.00,
"Ext_FT/020Price": 162.00,
"Ext_FT/100Price": 173.00,
"Ext_FT/160Price": 186.00,
"Ext_FT2/020Price": 162.00,
"Ext_FT2/100Price": 173.00,
"Ext_FT2/160Price": 186.00,
"Ext_FT3/020Price": 162.00,
"Ext_FT3/100Price": 173.00,
"Ext_FT3/160Price": 186.00,
"Ext_FT4/020Price": 248.00,
"Ext_FT4/100Price": 261.00,
"Ext_FT4/160Price": 273.00,
"Ext_FT5/020Price": 162.00,
"Ext_FT5/100Price": 173.00,
"Ext_FT5/160Price": 186.00,
"Ext_FT5.3/020Price": 162.00,
"Ext_FT5.3/100Price": 173.00,
"Ext_FT5.3/160Price": 186.00,
"Ext_FT9.3/020Price": 162.00,
"Ext_FT9.3/100Price": 173.00,
"Ext_FT9.3/160Price": 186.00,
"Ext_FT9/020Price": 162.00,
"Ext_FT9/100Price": 173.00,
"Ext_FT9/160Price": 186.00,
"Ext_FH/020Price": 162.00,
"Ext_FH/100Price": 173.00,
"Ext_FH/160Price": 186.00,
"Ext_FH2/020Price": 162.00,
"Ext_FH2/100Price": 173.00,
"Ext_FH2/160Price": 186.00,
"Ext_FH2.3/020Price": 162.00,
"Ext_FH2.3/100Price": 173.00,
"Ext_FH2.3/160Price": 186.00,
"Ext_FH3.3/020Price": 162.00,
"Ext_FH3.3/100Price": 173.00,
"Ext_FH3.3/160Price": 186.00,
"Ext_FH3/020Price": 162.00,
"Ext_FH3/100Price": 173.00,
"Ext_FH3/160Price": 186.00,
"Ext_FP/020Price": 162.00,
"Ext_FP/100Price": 173.00,
"Ext_FP/160Price": 186.00,
"Ext_FP2/020Price": 162.00,
"Ext_FP2/100Price": 173.00,
"Ext_FP2/160Price": 186.00,
"Ext_FP3/020Price": 261.00,
"Ext_FP3/100Price": 273.00,
"Ext_FP3/160Price": 287.00,
"Ext_FP4/020Price": 261.00,
"Ext_FP4/100Price": 273.00,
"Ext_FP4/160Price": 287.00,
"Ext_FP5/020Price": 162.00,
"Ext_FP5/100Price": 173.00,
"Ext_FP5/160Price": 186.00,
"Ext_FP6/020Price": 162.00,
"Ext_FP6/100Price": 173.00,
"Ext_FP6/160Price": 186.00,
"Ext_FP7/020Price": 162.00,
"Ext_FP7/100Price": 173.00,
"Ext_FP7/160Price": 186.00,
"Ext_FP8/020Price": 261.00,
"Ext_FP8/100Price": 273.00,
"Ext_FP8/160Price": 287.00,
"Ext_FP9/020Price": 261.00,
"Ext_FP9/100Price": 273.00,
"Ext_FP9/160Price": 287.00,
"Ext_FP10/020Price": 162.00,
"Ext_FP10/100Price": 173.00,
"Ext_FP10/160Price": 186.00,
"Ext_FP12/020Price": 261.00,
"Ext_FP12/100Price": 273.00,
"Ext_FP12/160Price": 287.00,
"Ext_FA/020Price": 162.00,
"Ext_FA/100Price": 173.00,
"Ext_FA/160Price": 186.00,
"Ext_FA3/020Price": 287.00,
"Ext_FA3/100Price": 297.00,
"Ext_FA3/160Price": 310.00,
"Ext_FA4/020Price": 261.00,
"Ext_FA4/100Price": 273.00,
"Ext_FA4/160Price": 287.00,
"Ext_FL/020Price": 162.00,
"Ext_FL/100Price": 173.00,
"Ext_FL/160Price": 186.00,
"Ext_FL2/020Price": 162.00,
"Ext_FL2/100Price": 173.00,
"Ext_FL2/160Price": 186.00,
"Ext_FL3/020Price": 162.00,
"Ext_FL3/100Price": 173.00,
"Ext_FL3/160Price": 186.00,
"Ext_FD/020Price": 162.00,
"Ext_FD/100Price": 173.00,
"Ext_FD/160Price": 186.00,
"Ext_FY/020Price": 74.00,
"Ext_FY/100Price": 86.00,
"Ext_FY/160Price": 98.00,
"Ext_FX/020Price": 74.00,
"Ext_FX/100Price": 86.00,
"Ext_FX/160Price": 98.00,
"Ana_EA/020Price": 248.00,
"Ana_EA/100Price": 261.00,
"Ana_EA/160Price": 273.00,
"Ana_EB/020Price": 248.00,
"Ana_EB/100Price": 261.00,
"Ana_EB/160Price": 273.00,
"Flx_FXH2/160Price": 186.00,
"Flx_FXH3/160Price": 186.00,
"Flx_FXL2/160Price": 186.00,
"Flx_FXL3/160Price": 186.00,
"Flx_FXT5/160Price": 186.00,
"Flx_FXT9/160Price": 186.00,
"Flx_FXP9/160Price": 287.00,
"Flx_FXP3/160Price": 287.00,
"Flx_FXP4/160Price": 287.00,
"Flx_FXP8/160Price": 287.00,
"Flx_FXP12/160Price": 287.00,
"Flx_FXA4/160Price": 287.00,
"Ana_EA/020Price": 248.00,
"Ana_EA/100Price": 261.00,
"Ana_EA/160Price": 273.00,
"Ana_EB/020Price": 248.00,
"Ana_EB/100Price": 261.00,
"Ana_EB/160Price": 273.00,
"Ana_E33Price": 186.00,
"Ana_E3333Price": 216.00,
"Ana_ExxPrice": 203.00,
"Ana_ExxxxPrice": 248.00,
"Add_N10006Price": 469.00,
"Add_N10109Price": 268.00,
"Add_N10110Price": 297.00,
"Add_N10111Price": 124.00,
"Add_N10112Price": 36.00,
"Add_N10113Price": 98.00,
"Add_N10115Price": 297.00,
"Add_N10121Price": 67.00,
"Add_N10129Price": 384.00,
"Add_N10130Price": 297.00
};